import db from "@/database";

export const findAll = () => db.vascularPhenomenon.toArray();
